export const getDouroData = () => ({
  name: "Douro",
  country: "Portugal",
  description: "Le Douro est la plus ancienne région viticole délimitée du monde, célèbre pour ses vins de Porto et ses rouges puissants issus de terrasses spectaculaires.",
  type: "region",
  area: "40,000 ha",
  production: "1.2 million hectolitres",
  climate: "Climat continental chaud, étés secs, hivers froids",
  soil: "Sols de schiste, terrasses escarpées",
  characteristics: {
    climate: "Climat continental chaud, étés secs, hivers froids",
    soil: "Sols de schiste, terrasses escarpées",
    viticulture: "Vendanges manuelles, cépages mélangés sur pied, vieilles vignes"
  },
  wineStyles: {
    red: "Rouges puissants, tanniques, grande capacité de garde",
    white: "Blancs minéraux et frais, production limitée",
    rosé: "Rosés délicats et fruités",
    fortified: "Porto : vin muté, styles variés (Ruby, Tawny, Vintage)",
    sparkling: "Vins effervescents de méthode traditionnelle"
  },
  history: "Le Douro est classé au patrimoine mondial de l'UNESCO. La production de Porto a débuté au XVIIe siècle. Les quintas historiques produisent des vins de renommée mondiale.",
  foodPairing: "Viandes rouges, gibier, fromages affinés, desserts au chocolat (Porto)",
  subregions: {
    "Baixo Corgo": {
      name: "Baixo Corgo",
      description: "Sous-région occidentale produisant des vins frais et fruités",
      area: "13,000 ha",
      characteristics: {
        climate: "Climat plus frais et humide",
        soil: "Sols de schiste et granit",
        viticulture: "Vendanges manuelles, terrasses traditionnelles"
      },
      grapeVarieties: {
        red: ["Touriga Nacional", "Tinta Roriz", "Tinta Barroca", "Tinto Cão"]
      }
    },
    "Cima Corgo": {
      name: "Cima Corgo",
      description: "Cœur du Porto de qualité, vins concentrés",
      area: "19,000 ha",
      characteristics: {
        climate: "Climat continental chaud",
        soil: "Sols de schiste escarpés",
        viticulture: "Vendanges manuelles, vieilles vignes"
      },
      grapeVarieties: {
        red: ["Touriga Nacional", "Tinta Roriz", "Tinta Barroca", "Tinto Cão"]
      }
    },
    "Douro Superior": {
      name: "Douro Superior",
      description: "Sous-région orientale aux vins puissants et concentrés",
      area: "8,000 ha",
      characteristics: {
        climate: "Climat chaud et sec",
        soil: "Sols de schiste et granit",
        viticulture: "Vendanges manuelles, rendements limités"
      },
      grapeVarieties: {
        red: ["Touriga Nacional", "Tinta Roriz", "Tinta Barroca", "Tinto Cão"]
      }
    }
  },
  grapeVarieties: [
    {
      name: "Touriga Nacional",
      percentage: "25%",
      description: "Cépage rouge noble, produisant des vins concentrés et aromatiques",
      characteristics: "Concentré, aromatique, tanins fins",
      wineStyles: "Sec, puissant, aromatique"
    },
    {
      name: "Tinta Roriz",
      percentage: "20%",
      description: "Cépage rouge produisant des vins équilibrés",
      characteristics: "Équilibré, fruité, tanins modérés",
      wineStyles: "Sec, équilibré, fruité"
    },
    {
      name: "Tinta Barroca",
      percentage: "15%",
      description: "Cépage rouge produisant des vins colorés",
      characteristics: "Coloré, fruité, tanins fins",
      wineStyles: "Sec, coloré, fruité"
    },
    {
      name: "Tinto Cão",
      percentage: "10%",
      description: "Cépage rouge produisant des vins fins",
      characteristics: "Fin, élégant, tanins fins",
      wineStyles: "Sec, fin, élégant"
    },
    {
      name: "Autres",
      percentage: "30%",
      description: "Autres cépages incluant des cépages autochtones",
      characteristics: "Diversifiés, expérimentaux",
      wineStyles: "Variés selon le cépage"
    }
  ],
  mapAreas: [
    { region: "Baixo Corgo", x: 38, y: 28, color: "#4B164C", size: 4 },
    { region: "Cima Corgo", x: 41, y: 30, color: "#6d2c7a", size: 6 },
    { region: "Douro Superior", x: 44, y: 32, color: "#8a4a8a", size: 5 }
  ],
  statistics: {
    totalArea: "40,000 ha",
    production: "1,200,000 hl",
    wineries: "250+ quintas",
    appellations: "3 sous-régions",
    exportPercentage: "70% (Porto)"
  }
}); 